import Configuration from '../config';
import { arabicDictionary, englishDictionary } from '../app/helpers/translate';
config.$inject = [ '', 'ivhTreeviewOptionsProvider' ];

config.$inject = [ '$logProvider', 'ConfigPmsApiServiceProvider', 'cfpLoadingBarProvider', '$translateProvider', 'toastrConfig' ];

/**
 * @param {$logProvider} $logProvider
 * @param {ConfigPmsApiServiceProvider} ConfigPmsApiServiceProvider
 * @param cfpLoadingBarProvider
 * @param $translateProvider
 */
export default function config($logProvider, ConfigPmsApiServiceProvider, cfpLoadingBarProvider, $translateProvider, toastrConfig) {

    $logProvider.debugEnabled(Configuration.DEBUG);

    ConfigPmsApiServiceProvider.config = {
        endpoint: Configuration.API_URL,
        authTokenGetter: [ 'AuthService', (AuthService) => AuthService.identifier ]
    };

    const PLEASE_WAIT = localStorage.getItem('lang') !== 'ar' ? englishDictionary.PLEASE_WAIT : arabicDictionary.PLEASE_WAIT;

    cfpLoadingBarProvider.loadingBarTemplate = '<div></div>';
    cfpLoadingBarProvider.spinnerTemplate =
    '<div class="modal loader-modal print-hidden">' +
        '<div class="modal-dialog">' +
            '<div class="modal-content">' +
                '<div class="modal-body">' +
                    '<span class="loader">' + PLEASE_WAIT + '</span>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';

    $translateProvider.translations('en', englishDictionary);
    $translateProvider.translations('ar', arabicDictionary,  { rtl : true } );
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.storageKey('lang');

    toastrConfig.positionClass = 'toast-bottom-left';
    toastrConfig.timeOut = 5000;
}



// WEBPACK FOOTER //
// ./src/app-core/core.config.js